import React, { useEffect, useState, createElement } from 'react';
import { Link } from 'react-router-dom';
import { SiteNavLinks } from '../components/SiteNavLinks';
import { supabase, SubscriberRow } from '../lib/supabase';
function formatDate(iso: string) {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    }).toLowerCase();
  } catch {
    return '';
  }
}
export function Subscribers() {
  const [subscribers, setSubscribers] = useState<SubscriberRow[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState('');
  useEffect(() => {
    const fetchSubscribers = async () => {
      setIsLoading(true);
      const {
        data,
        error
      } = await supabase.from('subscribers').select('*').order('created_at', {
        ascending: false
      });
      if (error) {
        setErrorMsg('could not load subscribers.');
        setSubscribers([]);
      } else {
        setSubscribers(data || []);
      }
      setIsLoading(false);
    };
    fetchSubscribers();
  }, []);
  const handleExportCsv = () => {
    if (subscribers.length === 0) return;
    const header = 'email,created_at';
    const rows = subscribers.map(s => `${s.email},${s.created_at}`).join('\n');
    const csv = `${header}\n${rows}`;
    const blob = new Blob([csv], {
      type: 'text/csv;charset=utf-8;'
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `subscribers-${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };
  return <main className="relative min-h-screen w-full bg-[#f5f5f5] px-6 py-6 text-black md:px-10 md:py-10" style={{
    fontFamily: 'Helvetica, "Helvetica Neue", Arial, "Arial Nova", sans-serif'
  }} data-id="element-258" data-mp="bj75igyc8udz">
      {/* Header — matches the rest of the site */}
      <header className="flex w-full items-start justify-between text-sm leading-tight" data-id="element-259" data-mp="3o0gnjtnowzjr">
        <Link to="/" className="lowercase hover:opacity-60" data-id="element-260" data-mp="3t1e0nrtuf3ee">
          lennon cripe
        </Link>

        <SiteNavLinks data-id="element-261" data-mp="3f1lf0ax6bdda" />

        <a href="mailto:info@weedwaster.com" className="lowercase hover:opacity-60" data-id="element-262" data-mp="3f2eeqrxpt2lx">
          contact
        </a>
      </header>

      {/* Page title + actions */}
      <section className="mt-20 flex w-full flex-col items-start text-sm md:mt-24" data-id="element-263" data-mp="bkczvyttyrm9">
        <p className="mb-2 font-bold lowercase" data-id="element-264" data-mp="fk511qgw9vhl">
          subscribers ({subscribers.length})
        </p>

        <div className="mb-6 flex items-center gap-6" data-id="element-265" data-mp="1tidmugl3s0t">
          <button onClick={handleExportCsv} disabled={subscribers.length === 0} className="lowercase hover:opacity-60 disabled:opacity-30" data-id="element-266" data-mp="6suvt1wigax2">
            export csv
          </button>
        </div>

        {/* List */}
        {isLoading ? <p className="lowercase text-black/50" data-id="element-267" data-mp="18o7nqto87sn3">loading...</p> : errorMsg ? <p className="lowercase text-black/50" data-id="element-268" data-mp="18lv0c0zp8q2n">{errorMsg}</p> : subscribers.length === 0 ? <p className="lowercase" data-id="element-269" data-mp="1ie11a07xihtz">no subscribers yet.</p> : <div className="flex w-full max-w-2xl flex-col gap-1" data-id="element-270" data-mp="1id944kyooc1l">
            {subscribers.map(s => <div key={s.id} className="flex w-full items-center justify-between" data-id="element-271" data-mp="1dh0uto763d2c">
                <span className="lowercase" data-id="element-272" data-mp="lo1jdf5w26yq">
                  {s.email}
                  <span className="ml-3 text-black/40" data-id="element-273" data-mp="lq4icop0rafl">
                    {formatDate(s.created_at)}
                  </span>
                </span>
              </div>)}
          </div>}

        <p className="mt-12 max-w-xl text-xs lowercase text-black/40" data-id="element-274" data-mp="uqstnbn12wos">
          to remove subscribers, manage them directly from the supabase
          dashboard under the "subscribers" table.
        </p>
      </section>

      <div className="h-24" data-id="element-275" data-mp="fn1739zm16ng" />
    </main>;
}